/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Component, EventEmitter, Input, Output} from '@angular/core';

let /** @type {?} */ wizardHeaderActionIndex = 0;
export class WizardHeaderAction {
    // title is explanatory text added to the header action
    
    title: string = "";

    // If our host has an ID attribute, we use this instead of our index.
    
    _id: string = (wizardHeaderActionIndex++).toString();
/**
 * @return {?}
 */
public get id(): string {
        return `clr-wizard-header-action-${this._id}`;
    }
public disabled: boolean = false;

     headerActionClicked: EventEmitter<string> = new EventEmitter(false);
/**
 * @return {?}
 */
click(): void {
        if (this.disabled) {
            return;
        }

        // passing the header action id allows users to have one method that
        // routes to many different actions based on the type of header action
        // clicked. this is further aided by users being able to specify ids
        // for their header actions.
        this.headerActionClicked.emit(this._id);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-wizard-header-action",
    template: `
        <button 
            type="button"
            class="btn clr-wizard-header-action btn-link"
            [id]="id"
            [class.disabled]="disabled"
            (click)="click()"
            [title]="title">
            <ng-content></ng-content>
        </button>
    `,
    host: {"class": "clr-wizard-header-action-wrapper"}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'title': [{ type: Input, args: ["title", ] },],
'_id': [{ type: Input, args: ["id", ] },],
'disabled': [{ type: Input, args: ["clrWizardHeaderActionDisabled", ] },],
'headerActionClicked': [{ type: Output, args: ["actionClicked", ] },],
};
}

function WizardHeaderAction_tsickle_Closure_declarations() {
/** @type {?} */
WizardHeaderAction.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WizardHeaderAction.ctorParameters;
/** @type {?} */
WizardHeaderAction.propDecorators;
/** @type {?} */
WizardHeaderAction.prototype.title;
/** @type {?} */
WizardHeaderAction.prototype._id;
/** @type {?} */
WizardHeaderAction.prototype.disabled;
/** @type {?} */
WizardHeaderAction.prototype.headerActionClicked;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
